import { useContext, useMemo } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import {
  SCORES,
  WEIGHTS,
} from 'layouts/authenticated/pages/dashboard/data/rpqData'

const MAX_SCORE = 7050
const MIN_SCORE = 1500

export const useRPQScore = () => {
  const { intakeState } = useContext(IntakeContext)

  const rpqScore = useMemo(() => {
    if (!intakeState?.riskAssessment?.isComplete) {
      return {
        score: null,
        weightedScore: null,
      }
    }

    let totalScore = 0

    if (intakeState?.riskAssessment?.topPriorities?.livingComfortably) {
      totalScore +=
        SCORES.topPriorities.livingComfortably * WEIGHTS.topPriorities
    }
    if (intakeState?.riskAssessment?.topPriorities?.growth) {
      totalScore += SCORES.topPriorities.growth * WEIGHTS.topPriorities
    }
    if (intakeState?.riskAssessment?.topPriorities?.legacy) {
      totalScore += SCORES.topPriorities.legacy * WEIGHTS.topPriorities
    }

    if (intakeState?.riskAssessment?.investorProfile) {
      const profileScore =
        SCORES.investorProfile[intakeState.riskAssessment.investorProfile] || 0
      totalScore += profileScore * WEIGHTS.investorProfile
    }

    const familiarityTopics = [
      'stocks',
      'bonds',
      'checking',
      'lifeInsurance',
      'annuities',
      'pensions',
      'tsp',
      'cd',
    ]

    let familiarityScore = 0
    let familiarityCount = 0

    familiarityTopics.forEach((topic) => {
      if (intakeState?.riskAssessment?.financialFamiliarity?.[topic]) {
        familiarityScore += SCORES.financialFamiliarity[topic]
        familiarityCount++
      }
    })

    if (familiarityCount > 0) {
      totalScore += familiarityScore * WEIGHTS.financialFamiliarity
    }

    if (intakeState?.riskAssessment?.coinFlip?.['200100']) {
      const coinFlipValue = intakeState.riskAssessment.coinFlip['200100']
      totalScore +=
        SCORES.coinFlip['200100'][coinFlipValue] * WEIGHTS.coinFlip['200100']
    }

    if (intakeState?.riskAssessment?.coinFlip?.['300100']) {
      const coinFlipValue = intakeState.riskAssessment.coinFlip['300100']
      totalScore +=
        SCORES.coinFlip['300100'][coinFlipValue] * WEIGHTS.coinFlip['300100']
    }

    if (intakeState?.riskAssessment?.coinFlip?.['20001000']) {
      const coinFlipValue = intakeState.riskAssessment.coinFlip['20001000']
      totalScore +=
        SCORES.coinFlip['20001000'][coinFlipValue] *
        WEIGHTS.coinFlip['20001000']
    }

    if (intakeState?.riskAssessment?.coinFlip?.['30001000']) {
      const coinFlipValue = intakeState.riskAssessment.coinFlip['30001000']
      totalScore +=
        SCORES.coinFlip['30001000'][coinFlipValue] *
        WEIGHTS.coinFlip['30001000']
    }

    if (intakeState?.riskAssessment?.hypotheticalInvestment) {
      const investmentScore =
        SCORES.hypotheticalInvestment[
          intakeState.riskAssessment.hypotheticalInvestment
        ] || 0
      totalScore += investmentScore * WEIGHTS.hypotheticalInvestment
    }

    let tempWeightedScore = Math.round(
      ((totalScore - MIN_SCORE) / (MAX_SCORE - MIN_SCORE)) * 10
    )
    if (tempWeightedScore >= 0 && tempWeightedScore <= 1) {
      tempWeightedScore = 1
    }

    // console.log('totalScore', totalScore)
    // console.log('tempWeightedScore', tempWeightedScore)
    return {
      score: totalScore,
      weightedScore: tempWeightedScore,
    }
  }, [intakeState?.riskAssessment])

  return rpqScore
}
